import { VInput } from 'vuetify/lib/components/VInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VInput,{attrs:{"hide-details":_vm.size=='sm'}},[_c('div',{staticClass:"outer",style:(_vm.style)},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"value-holder"},[_c('copyable',[_c('div',{staticClass:"value",class:{'large-text' : _vm.largeText}},[_vm._t("default"),_c('span',{staticClass:"suffix"},[_vm._t("suffix")],2)],2)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }